// @flow
import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Button, Svg } from '@gandi/ui';

import CallToAction from './CallToAction';

import styles from './BulkAddToCart.scss';

type DoneProps = {
  translator: TranslatorProps,
  onClick: (
    evt: SyntheticMouseEvent<HTMLAnchorElement | HTMLButtonElement>,
  ) => Promise<void>,
};
function Done({ translator, onClick }: DoneProps) {
  const { __ } = translator;

  return (
    <span className={styles.Done}>
      <Svg name="checkmark" theme="success" />
      <span>{translator.__('Domains added to your cart.')}</span>{' '}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a href="#" role="button" onClick={onClick}>
        {__('Remove')}
      </a>
    </span>
  );
}

export type OwnProps = {
  translator: TranslatorProps,
};

export type StateProps = {
  addedToCart: boolean,
  cartId: string,
};

export type DispatchProps = {
  addAllToCart: (translator: TranslatorProps) => Promise<void>,
  removeAllFromCart: () => Promise<void>,
};

export type Props = {
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
};

const handleClick =
  (
    setLoading: boolean => void,
    translator: TranslatorProps,
    action: TranslatorProps => Promise<void>,
  ) =>
  async (evt: SyntheticMouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    evt.preventDefault();
    setLoading(true);
    try {
      // renew action need translator
      // addAllToCArt nees translator
      await action(translator);
    } finally {
      setLoading(false);
    }
  };

export default function BulkAddToCart(props: Props): React.Node {
  const { translator, addedToCart, cartId } = props;
  const { __ } = translator;

  const [loading, setLoading] = React.useState(false);

  return (
    <CallToAction>
      {addedToCart && (
        <Done
          translator={translator}
          onClick={handleClick(setLoading, translator, props.removeAllFromCart)}
        />
      )}
      {!addedToCart ? (
        <Button
          disabled={loading}
          onClick={handleClick(setLoading, translator, props.addAllToCart)}
        >
          {__('Add to cart')}
        </Button>
      ) : (
        <Button to={`/cart/${cartId}/overview`}>{__('Checkout')}</Button>
      )}
    </CallToAction>
  );
}
